import { UseNavigationReturnType } from '@dtx-company/inter-app/src/hooks/useNavigation'
import { theme } from '@dtx-company/shared-components/src'
import { useRouter } from 'next/router'

interface TopNavV2Props {
  hasScrolledPastTopNav: boolean
}
interface TopNavV2State {
  backgroundColor: UseNavigationReturnType['navBackgroundColor']
  borderBottom: UseNavigationReturnType['navBottomBorder']
}

const NAV_BOTTOM_BORDER = ['none', 'none', 'none', `1px solid ${theme.colors.secondary.border}`]

export const useTopNavV2 = ({ hasScrolledPastTopNav = false }: TopNavV2Props): TopNavV2State => {
  const navColor = 'primary.white'

  const router = useRouter()

  const isAmexPage = (router?.pathname ?? '').includes('/pro/amex')
  const backgroundColor = isAmexPage ? '#026FCF' : navColor

  return {
    backgroundColor,
    borderBottom: hasScrolledPastTopNav ? NAV_BOTTOM_BORDER : ''
  }
}
